import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CheckinsFiltersComponent } from './components/checkins-filters/checkins-filters.component';
import { CheckinsTableComponent } from './components/checkins-table/checkins-table.component';
import { CheckinFilter } from './models/checkin-filter.model';
import { CheckinRow } from './models/checkin.model';
import { CheckinService } from './services/checkin.service';

@Component({
  selector: 'app-checkins',
  standalone: true,
  imports: [CommonModule, TranslateModule, CheckinsFiltersComponent, CheckinsTableComponent],
  template: `
    <div class="card container-fluid p-5">
      <div class="mb-4 flex items-center justify-between">
        <h1 class="text-3xl font-semibold">{{ 'checkins.title' | translate }}</h1>
      </div>

      <!-- Filters Component -->
      <app-checkins-filters
        [activeFilter]="filter"
        (filterChange)="onFilterChange($event)"
      ></app-checkins-filters>

      <!-- Table Component -->
      <app-checkins-table
        [filter]="filter"
        (viewCheckinDetails)="onViewCheckinDetails($event)"
      ></app-checkins-table>
    </div>
  `
})
export class CheckinsComponent implements OnInit {
  // Data properties
  checkins: CheckinRow[] = [];
  loading = false;
  error: string | null = null;
  totalItems = 0;

  // Pagination properties
  currentPage = 1;
  itemsPerPage = 30;

  // Sorting properties
  sortField: string | null = null;
  sortOrder: 'asc' | 'desc' | null = null;

  // Filter properties
  filter: CheckinFilter = {};

  constructor(
    private checkinService: CheckinService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // No need to load checkins here as the table component will handle this
  }

  /**
   * Handle filter change from the filter component
   * @param filter New filter values
   */

  onFilterChange(filter: CheckinFilter): void {
    this.filter = filter;
  }

  /**
   * Handle view checkin details event from table
   * @param id Checkin ID to view
   */
  onViewCheckinDetails(id: string): void {
    this.router.navigate(['/checkins', id]);
  }
}
